const wrapper = "_arawztepct";
const logo = "_araljl1tu9";
const textWrapper = "_arat17gcnq0";

export { logo, textWrapper, wrapper };
import "./atom.header.style.linaria.module.css";
//# sourceMappingURL=atom.header.style.js.map
